module.exports = __webpack_public_path__ + "img/img-158.1cd99d6a.png";